import { render, staticRenderFns } from "./followState.vue?vue&type=template&id=9a884d56&scoped=true"
import script from "./followState.vue?vue&type=script&lang=js"
export * from "./followState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a884d56",
  null
  
)

export default component.exports